import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SessionRecordingStateService } from '../session-recording-state.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-authenticated-shell',
  template: '<router-outlet />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AuthenticatedShellComponent {
  //serivce regisztálása
  private readonly recordingState = inject(SessionRecordingStateService);
}
